import { render, staticRenderFns } from "./LiquidacionResumen.vue?vue&type=template&id=faa74eb0&scoped=true&"
import script from "./LiquidacionResumen.vue?vue&type=script&lang=js&"
export * from "./LiquidacionResumen.vue?vue&type=script&lang=js&"
import style0 from "./LiquidacionResumen.vue?vue&type=style&index=0&id=faa74eb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa74eb0",
  null
  
)

export default component.exports